import { AnsweringClient } from "../clients/answeringClient";

export interface FinishScreenControllerDelegate {
  applicationShouldLogout(): void;
  genericError(): void;
  didGetAllowFeedback(allowFeedback: boolean): void;
  didGetAssignmentToken(token: string): void;
  didClickSeeResults(assignmentId: number): void;
}

export class FinishScreenController {
  constructor (
    private delegate: FinishScreenControllerDelegate,
    private readonly answeringClient = new AnsweringClient()
  ) { }

  public async getAllowFeedback(accessToken: string, instrumentId: string) {
    try {
      const response = await this.answeringClient.getAllowFeedback(accessToken, instrumentId);
      this.delegate.didGetAllowFeedback(response.data.allowFeedback);
    } catch (error: any) {
      if(error?.response?.status === 403) {
        const newTokens = await this.refreshTokens();
        if(!newTokens) {
          return;
        }
        this.getAllowFeedback(newTokens.accessToken, instrumentId);
        return;
      }
      this.delegate.genericError();
    }
  }


  private async refreshTokens(): Promise<{accessToken: string, refreshToken: string} | void> {
    const refreshToken = localStorage.getItem("RefreshToken");
    if(!refreshToken) {
      this.delegate.applicationShouldLogout();
      return;
    }
    try {
      const response = await this.answeringClient.refreshToken(refreshToken);
      const tokens: {accessToken: string, refreshToken: string} = response.data;
      localStorage.setItem("AccessToken", tokens.accessToken);
      localStorage.setItem("RefreshToken", tokens.refreshToken);
      return tokens;
    } catch (error: any) {
      this.delegate.applicationShouldLogout();
      return;
    } 
  }

  public async getAssignmentFeedbackToken(accessToken: string, assignmentId: number) {
    try {
      const response = await this.answeringClient.getAssignmentFeedbackToken(accessToken, assignmentId);
      const token = response.data.token;
      this.delegate.didGetAssignmentToken(token);
    } catch (error: any) {
      if(error?.response?.status === 403) {
        const newTokens = await this.refreshTokens();
        if(!newTokens) {
          return;
        }
        this.getAssignmentFeedbackToken(newTokens.accessToken, assignmentId);
        return;
      }
      this.delegate.genericError();
    }
  }

  didClickSeeResults(assignmentId: number) {
    this.delegate.didClickSeeResults(assignmentId);
  }

}